<div class="w-[90vw] max-w-[40rem]">
  <app-card>
    <ng-content></ng-content>
  </app-card>
</div>
